/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Configuration } from '../../Configuration';
import { State } from '../../model/State';

// Services
import { PreventiveSheetAttachmentServiceProvider } from './service/PreventiveSheetAttachmentServiceProvider';
import { PreventiveSheetServiceProvider } from './service/PreventiveSheetServiceProvider';
import { PreventiveSheetTemplateServiceProvider } from './service/PreventiveSheetTemplateServiceProvider';

// Components
import { gmaoPreventivePlanningWeekComponent } from './component/GmaoPreventivePlanningWeek';
import { preventivePlanningComponent } from './component/PreventivePlanning';
import { preventiveSheetListComponent } from './component/PreventiveSheetList';
import { preventiveSheetTemplateListComponent } from './component/PreventiveSheetTemplateList';
import { preventiveSheetTemplateViewComponent } from './component/PreventiveSheetTemplateView';
import { preventiveSheetViewComponent } from './component/PreventiveSheetView';
import { preventiveSheetImportsExportsComponent } from "./component/PreventiveSheetImportsExports";

angular.module('serfimtic.gmao.prevention', ['ui.router', 'ngResource'])
.provider('preventiveSheetService', PreventiveSheetServiceProvider)
.provider('preventiveSheetAttachmentService', PreventiveSheetAttachmentServiceProvider)
.provider('preventiveSheetTemplateService', PreventiveSheetTemplateServiceProvider)
.component('gmaoPreventivePlanningWeek', gmaoPreventivePlanningWeekComponent)
.component('preventivePlanning', preventivePlanningComponent)
.component('preventiveSheetList', preventiveSheetListComponent)
.component('preventiveSheetTemplateView', preventiveSheetTemplateViewComponent)
.component('preventiveSheetTemplateList', preventiveSheetTemplateListComponent)
.component('preventiveSheetView', preventiveSheetViewComponent)
.component('preventiveSheetImportsExports', preventiveSheetImportsExportsComponent)
.config($stateProvider => {
    /** @ngInject */
    $stateProvider
        .state(State.abstractUrlState('gmao.preventivesheet', '/preventive-sheet', ['ADMIN', 'PREVENTIVE_SHEET_READ']))
        .state(State.componentState('gmao.preventivesheet.planning', 'preventivePlanning', '/planning',
            'ui.preventiveplanning'))
        .state(State.componentStateWithFilter('gmao.preventivesheet.list', 'preventiveSheetList', '/list',
            'ui.preventivesheet.list'))
        .state(State.componentState('gmao.preventivesheet.create', 'preventiveSheetView', '/create',
            'ui.preventivesheet.creation', {plannedWeek: undefined}, ['ADMIN', 'PREVENTIVE_SHEET_CREATE']))
        .state(State.componentState('gmao.preventivesheet.update', 'preventiveSheetView', '/update/:id',
            'model.preventivesheet.preventivesheet', undefined, ['ADMIN', 'PREVENTIVE_SHEET_READ']))
        .state(State.componentState('gmao.preventivesheet.importsexports', 'preventiveSheetImportsExports', '/imports-exports',
            'ui.preventivesheet.importsexports', ['ADMIN', 'PREVENTIVE_SHEET_CREATE']))

        .state(State.abstractUrlState('gmao.preventivesheet.template', '/template', ['ADMIN']))
        .state(State.componentState('gmao.preventivesheet.template.list', 'preventiveSheetTemplateList', '/list',
            'ui.preventivesheettemplate.list'))
        .state(State.componentState('gmao.preventivesheet.template.create', 'preventiveSheetTemplateView',
            '/create', 'ui.preventivesheettemplate.creation'))
        .state(State.componentState('gmao.preventivesheet.template.update', 'preventiveSheetTemplateView',
            '/update/:id', 'ui.preventivesheettemplate.update'));
})
.config(preventiveSheetAttachmentServiceProvider => {
    /** @ngInject */
    preventiveSheetAttachmentServiceProvider.setResourceUrl(Configuration.PREVENTIVE_SHEET_ATTACHMENT_PATH);
})
.config(preventiveSheetServiceProvider => {
    /** @ngInject */
    preventiveSheetServiceProvider.setResourceUrl(Configuration.PREVENTIVE_SHEET_PATH);
})
.config(preventiveSheetTemplateServiceProvider => {
    /** @ngInject */
    preventiveSheetTemplateServiceProvider.setResourceUrl(Configuration.PREVENTIVE_SHEET_TEMPLATE_PATH);
});



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/prevention/PreventionModule.js